export const SHELL_APP = 'shell';
